import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'SEAWAYBILL',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
  staffOnly: false,
};
